import styled from 'styled-components';

export const Wrapper = styled.div`
  height: calc(100% - 60px);
  position: fixed;
  right: 60px;
  top: 60px;
  width: 500px;
  z-index: 2000;
  background-color: ${props => props.theme.themeColors.sidebars.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
  @media all and (max-width: 1200px) {
    width: calc(50% - 60px);
  }
`;

export const WrapperLoad = styled.div`
  height: calc(100% - 60px);
  position: fixed;
  right: 60px;
  top: 60px;
  width: 500px;
  z-index: 2000;
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.themeColors.sidebars.background};
  border-left: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  justify-content: center;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
`;

export const StyledHeader = styled.div`
  align-items: center;
  background: ${({ theme }) =>
    theme.themeColors.sidebars.bookmarks.headerBackground};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  min-height: 40px;
  width: 100%;
  position: relative;
`;

export const BtnBlock = styled.div`
  display: flex;
  flex-wrap: nowrap;
  position: absolute;
  top: 0;
  right: 0;
`;

export const CloseBtn = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  width: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  & > svg {
    height: 30px;
    width: 30px;
  }
  &:hover {
    background: rgba(0,0,0,.1);
  }
`;

export const StyledBody = styled.div`
  height: calc(100% - 40px);
  overflow-y: auto;
`;

export const StyledBodyLoad = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props =>
  props.active
    ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
    : props.theme.themeColors.sidebars.thumbnails.textColor};
  height: calc(100% - 40px);
  overflow-y: auto;
`;

export const DocCard = styled.div`
  background: ${props => props.theme.themeColors.controlBar.background};
  margin: 10px;
  display: grid;
  height: auto;
  position: relative;
`;

export const DocItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  height: auto;
  padding: 15px;
  text-decoration: none;
`;

export const DocItemLink = styled.a`
  display: grid;
  grid-template-columns: 1fr;
  height: auto;
  padding: 15px;
  text-decoration: none;
`;

export const IconBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextBlock = styled.div`  
  display: flex;
  align-items: center;
  gap: 0;
`;

export const Text = styled.div`
  color: ${props =>
  props.active
    ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
    : props.theme.themeColors.sidebars.thumbnails.textColor};
  &:nth-child(2) {
    color: ${props =>
    props.active
      ? props.theme.themeColors.sidebars.thumbnails.textColorOnActive
      : props.theme.themeColors.sidebars.thumbnails.textColor};
    font-size: 14px;
  }
`;